import React, { useMemo } from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { ThemeProvider } from '@material-ui/styles'
import { renderRoutes } from 'react-router-config'
import { SnackbarProvider } from 'notistack'

import theme from './theme'

import routes from './routes'
import { ScrollReset, GoogleAnalytics, AuthGuard } from './components'
import './mixins/chartjs'
import './assets/css/index.css'
import { Button } from '@material-ui/core'
import ErrorBoundary from 'components/ErrorBoundary'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { setFile } from 'redux/actions'

const env = process.env.REACT_APP_ENV
const basename =
  env === 'development'
    ? process.env.PUBLIC_URL + '/dev'
    : process.env.PUBLIC_URL

const history = createBrowserHistory({
  basename: basename
})

const App = () => {
  const notistackRef = React.createRef()
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key)
  }

  const dispatch = useDispatch()

  const { cards, SelectedCard } = useSelector(
    state => state.newCampaign.placement,
    shallowEqual
  )

  const isFailed = useMemo(() => cards[SelectedCard.name]?.failed, [
    SelectedCard.name,
    cards
  ])

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={5}
          onClose={() => {
            if (isFailed) dispatch(setFile({ failed: false }))
          }}
          ref={notistackRef}
          action={key => (
            <Button color="inherit" onClick={onClickDismiss(key)}>
              Dismiss
            </Button>
          )}>
          <Router history={history}>
            <AuthGuard>
              <ScrollReset />
              <GoogleAnalytics />
              {renderRoutes(routes)}
            </AuthGuard>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App
